export const byStatus = (statuses) => (link) => {
  if (!statuses?.length) return true;
  return statuses.includes(link.status);
};
